import {requirePermission} from '@/modules/auth/permissions'
import {UserForm} from '@/modules/users/components'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const SearchSchema = z.object({
  userId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/users/new')({
  beforeLoad: requirePermission('users.manage'),
  component: NewUserPage,
  validateSearch: SearchSchema,
})

function NewUserPage() {
  const {t} = useTranslate('users')
  const {userId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={userId ? t('edit_user_title') : t('new_user_title')}
        description={t('new_user_description')}
      />

      <UserForm userId={userId} />
    </NewResourceFormContainer>
  )
}
